(function($, document, window, lq) {

    // Fonction qui ouvre l'accordeon spécifié par l'ancre de l'url
    var openAnchorCollapse = function() {
        var anchor = window.location.hash;
        if($(anchor).hasClass("accordeon")) {
            var accordeonCollapse = $(anchor.replace('#','#collapse-'))
            // Si l'accordeon est fermé
            if (!accordeonCollapse.hasClass('show')) {
                var accordeonButton = $(anchor + " button:first");
                accordeonButton.trigger('click');
            }
        }
    }

    lq.accordeon = (function() {
        return {
            initAccordeon: function() {

                $('.collapse').on('show.bs.collapse', function() {

                    $(this).parent().find(".accordeon__icone-header").removeClass("plus").addClass("minus");

                }).on('hide.bs.collapse', function() {

                    $(this).parent().find(".accordeon__icone-header").removeClass("minus").addClass("plus");

                });

                /*
                    Créer une ancre à partir de l'éditeur riche dans une zone texte:
                        - cliquer sur l'icône lien dans l'éditeur riche
                        - entrer le texte du lien
                        - sélectionner pour 'Type de lien' Ancre
                        - sélectionner l'onglet 'Avancé'
                        - entrer le 'nom' identique au nom qui a été renseigné au niveau de l'accordéon pour le champ ancre
                        - entrer la 'Classes de style' comme ancre-acc
                        - sauvegarder   
                */
                $("a[class^='ancre-acc']").click(function(e) {
                    e.preventDefault();
                    var ancre = $(this).attr("name");
                    var acc = $('div[name="' + ancre + '"]');
                    var zone = acc.children(".accordeon-body");
                    zone.removeClass('hide');
                    zone.addClass('show');
                    var zoneImg = acc.find(".accordeon__icone-header");
                    zoneImg.removeClass('plus');
                    zoneImg.addClass('minus');
                    position = acc.offset();
                    window.scrollTo(0, position.top);

                });

                // Quand l'ancre de la page change, ouvre l'accordeon
                $( window ).on( 'hashchange', function(e) {
                    openAnchorCollapse();
                });
            },
            openCollapse : openAnchorCollapse
        };
    })();

    window.lq = lq;

    //--> Auto trigger all self implemented functionalities on document ready
    lq.load.push(
        "lq.accordeon", [
            'initAccordeon',
            'openCollapse'
        ]
    );

}($, document, window, (window.lq || {})));